import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { routerPath } from "../../navigation/path";
import { IMAGES } from "../../../assets/images";
import { useDispatch, useSelector } from "react-redux";
import { login, logout } from "../../../store/slices/userSlice";
import { Modal } from "react-bootstrap";

const Header = () => {
  const location = useLocation();
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userName = useSelector((state) => state.users.user?.name || "");
  const TotalSavings = useSelector((state) => state.categories.savings);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {});

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  const sendToMenu = (menu) => {
    menu == "home" && navigate(routerPath.home);
    menu == "about" && navigate(routerPath.about);
    menu == "offer" && navigate(routerPath.offer);
    // menu == "previlages" && navigate(routerPath.previlages);
    // menu == "your-offers" && navigate(routerPath.yourOffers);
    menu == "orderHistory" && navigate(routerPath.OrderHistory);
    menu == "profile" && navigate(routerPath.profile);
    menu == "my-account" && navigate(routerPath.myAccount);
    menu == "savings" && navigate(routerPath.savings);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const logoutUser = () => {
    setShowModal(true);
    // dispatch(logout())
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      <MobileMenu isOpen={isSidebarOpen} onClose={toggleSidebar} />
      <header className="bg-[#FFFFFF] py-3">
        <div className="flex items-center px-2">
          <div
            className="text-white text-xl font-bold flex-1 cursor-pointer"
            onClick={() => sendToMenu("home")}
          >
            <img src={IMAGES.logo} alt="" className="w-50" />
          </div>
          <div className="block lg:hidden">
            <button
              onClick={toggleSidebar}
              className="text-[#0673EA] focus:outline-none p-2 hover:bg-gray-100 rounded"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                ></path>
              </svg>
            </button>
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:flex lg:flex-[2] flex-wrap gap-6 justify-center">
            <p
              className={`mb-0 text-[16px] font-semibold text-center cursor-pointer ${isActive(routerPath.home) ? "text-[#0673EA] font-bold" : "text-[#515B6F]"}`}
              onClick={() => sendToMenu("home")}
            >
              Home
            </p>
            <p
              className={`mb-0 text-[16px] font-semibold text-center cursor-pointer ${isActive(routerPath.about) ? "text-[#0673EA] font-bold" : "text-[#515B6F]"}`}
              onClick={() => sendToMenu("about")}
            >
              About Us
            </p>
            <p
              className={`mb-0 text-[16px] font-semibold text-center cursor-pointer ${isActive(routerPath.offer) ? "text-[#0673EA] font-bold" : "text-[#515B6F]"}`}
              onClick={() => sendToMenu("offer")}
            >
              Offers
            </p>
            {/* <p
              className={`mb-0 text-[16px] font-semibold text-center cursor-pointer ${isActive(routerPath.previlages) ? "text-[#0673EA] font-bold" : "text-[#515B6F]"}`}
              onClick={() => sendToMenu("previlages")}
            >
              Privileges
            </p> */}
            {/* <p
              className={`mb-0 text-[16px] font-semibold text-center cursor-pointer ${isActive(routerPath.yourOffers) ? "text-[#0673EA] font-bold" : "text-[#515B6F]"}`}
              onClick={() => sendToMenu("your-offers")}
            >
              Your Offers
            </p> */}
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="lg:hidden absolute top-0 left-0 w-full h-screen bg-[#0673EA]">
              <div className="flex flex-col  pt-8 space-y-4">
                <div className="text-end pr-5">
                  <button
                    onClick={toggleMenu}
                    className="text-white focus:outline-none focus:text-white"
                  >
                    <svg
                      className="h-6 w-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 6h16M4 12h16m-7 6h7"
                      ></path>
                    </svg>
                  </button>
                </div>

                <ul>
                  <li
                    className="text-white justify-between items-left cursor-pointer pt-3 flex"
                    onClick={() => sendToMenu("home")}
                  >
                    Home
                  </li>
                  <li
                    className="text-white justify-between items-left cursor-pointer flex pt-3"
                    onClick={() => sendToMenu("about")}
                  >
                    About Us
                  </li>
                  <li
                    className="text-white justify-between items-left cursor-pointer flex pt-3"
                    onClick={() => sendToMenu("offer")}
                  >
                    Offers
                  </li>
                  <li
                    className="text-white justify-between items-left cursor-pointer flex pt-3"
                    onClick={() => sendToMenu("previlages")}
                  >
                    Privileges
                  </li>
                  <li
                    className="text-white justify-between items-left cursor-pointer flex pt-3"
                    onClick={() => sendToMenu("your-offers")}
                  >
                    Privileges
                  </li>
                  <li
                    className="text-white justify-between items-center w-32 font-bold cursor-pointer"
                    onClick={logoutUser}
                  >
                    Logout
                  </li>
                </ul>
              </div>
            </div>
          )}

          {/*User Details */}

          <div className="hidden lg:flex lg:flex-[2] lg:justify-end lg:gap-2">
            {/* <div className="border-r-[1px] border-[#D6DDEB] px-[16px]">
              <button
                type="btn"
                className="bg-[#21438F] py-[10px] px-[16px] rounded-[4px] text-[14px] font-bold text-white whitespace-nowrap"
                onClick={() => sendToMenu("savings")}
              >
                Your Savings : {TotalSavings}
              </button>
            </div> */}
            <div className="border-r-[1px] border-[#D6DDEB] flex items-center px-[16px]">
              <button
                type="button"
                className="bg-[#0A142F] py-[10px] px-[16px] rounded-[4px] text-[14px] font-bold text-white whitespace-nowrap"
                onClick={() => navigate(routerPath.purchasePlan)}
              >
                Subscribe
              </button>
            </div>
            <div className="border-r-[1px] border-[#D6DDEB] py-[10px] px-[16px]">
              <p
                className="m-0 text-[#21438F] text-[14px] font-bold cursor-pointer whitespace-nowrap"
                onClick={() => sendToMenu("my-account")}
              >
                {userName}
              </p>
            </div>
            <div className="cursor-pointer py-[10px] px-[16px]">
              <p
                className="m-0 text-[#21438F] text-[14px] font-bold whitespace-nowrap"
                onClick={logoutUser}
              >
                Logout
              </p>
            </div>
          </div>
        </div>

        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
          size="md"
        >
          <Modal.Body>
            <div>
              <h4 className="pt-2">Are you sure you want to Logout ?</h4>
              <div className="flex mt-4">
                <button
                  className="w-[48%] mx-[1%] bg-red-700 text-white h-[40px] rounded"
                  onClick={() => setShowModal(false)}
                >
                  No
                </button>
                <button
                  className="w-[48%] mx-[1%] bg-green-700 text-white h-[40px] rounded"
                  onClick={() => {
                    dispatch(logout());
                    localStorage.clear();
                    localStorage.setItem("currentPath", "/login");
                    navigate(routerPath.Login);
                  }}
                >
                  Yes
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </header>
    </>
  );
};

export default Header;

const MobileMenu = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userName = useSelector((state) => state.users.user?.name || "");
  const TotalSavings = useSelector((state) => state.categories.savings);
  const [showModal, setShowModal] = useState(false);

  const sendToMenu = (menu) => {
    console.log(menu);
    menu == "home" && navigate(routerPath.home);
    menu == "about" && navigate(routerPath.about);
    menu == "offer" && navigate(routerPath.offer);
    menu == "orderHistory" && navigate(routerPath.orders);
    menu == "profile" && navigate(routerPath.profile);
    menu == "my-account" && navigate(routerPath.myAccount);
    menu == "savings" && navigate(routerPath.savings);
    onClose(); // Close menu after navigation
  };

  const handleLogout = () => {
    setShowModal(true);
  };

  const confirmLogout = () => {
    dispatch(logout());
    localStorage.clear();
    localStorage.setItem("currentPath", "/login");
    navigate(routerPath.Login);
    onClose();
  };

  const isUserLogin = userName !== "";

  return (
    <>
      {/* Backdrop overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <div
        className={`fixed w-[85vw] max-w-[320px] inset-y-0 left-0 bg-[#0A142F] z-50 transform transition-transform duration-300 ease-in-out ${isOpen ? "translate-x-0" : "-translate-x-full"}`}
      >
        <div className="flex items-center justify-between p-4 cursor-pointer">
          {/* <h1 className="text-black text-lg font-semibold">Product categories</h1> */}
          <img
            src={IMAGES.logo}
            alt=""
            className="w-[60px]"
            onClick={() => sendToMenu("home")}
          />
          <button onClick={onClose} className="text-white focus:outline-none">
            <svg
              className="h-6 w-6 fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M12.3 10l5.4-5.4c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-5.4 5.4-5.4-5.4c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l5.4 5.4-5.4 5.4c-.4.4-.4 1 0 1.4.2.2.4.3.7.3s.5-.1.7-.3l5.4-5.4 5.4 5.4c.2.2.4.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4l-5.4-5.4z"></path>
            </svg>
          </button>
        </div>
        <div className="overflow-y-auto h-full pb-20">
          {/* Sidebar content */}
          <div className="px-4 mt-5">
            <div className="ml-4 pb-5">
              <p
                className="text-white font-bold cursor-pointer mb-4 hover:text-blue-300 transition-colors"
                onClick={() => sendToMenu("home")}
              >
                Home
              </p>
              <p
                className="text-white font-bold cursor-pointer mb-4 hover:text-blue-300 transition-colors"
                onClick={() => sendToMenu("about")}
              >
                About Us
              </p>
              <p
                className="text-white font-bold cursor-pointer mb-4 hover:text-blue-300 transition-colors"
                onClick={() => sendToMenu("offer")}
              >
                Offers
              </p>

              {isUserLogin && (
                <>
                  <div className="border-t border-blue-400 my-4 pt-4">
                    <p className="text-blue-200 text-sm mb-3">Account</p>
                    <p
                      className="text-white font-bold cursor-pointer mb-4 hover:text-blue-300 transition-colors"
                      onClick={() => sendToMenu("my-account")}
                    >
                      Dashboard
                    </p>
                    <p
                      className="text-white font-bold cursor-pointer mb-4 hover:text-blue-300 transition-colors"
                      onClick={() => sendToMenu("orderHistory")}
                    >
                      Orders
                    </p>
                    <p
                      className="text-white font-bold cursor-pointer mb-4 hover:text-blue-300 transition-colors"
                      onClick={() => sendToMenu("savings")}
                    >
                      Your Savings ({TotalSavings})
                    </p>
                  </div>

                  <div className="border-t border-blue-400 my-4 pt-4">
                    <p className="text-blue-200 text-sm mb-2">Logged in as</p>
                    <p className="text-white font-semibold mb-4">{userName}</p>
                    <button
                      className="bg-red-600 text-white font-bold py-2 px-6 rounded hover:bg-red-700 transition-colors"
                      onClick={handleLogout}
                    >
                      Logout
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        {/* Logout Modal for Mobile */}
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
          size="sm"
        >
          <Modal.Body>
            <div>
              <h5 className="pt-2">Are you sure you want to Logout?</h5>
              <div className="flex mt-4 gap-2">
                <button
                  className="flex-1 bg-gray-500 text-white h-[40px] rounded hover:bg-gray-600"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="flex-1 bg-red-600 text-white h-[40px] rounded hover:bg-red-700"
                  onClick={confirmLogout}
                >
                  Logout
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};
